export default {
  getInforOrder: state => state.orders,
  getIdOrder: state => state.orderId,
  getSaveOrder: state => state.orderSave
};
